import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class AccordionController extends Controller {
    static targets = ['content'];

    toggle(event) {
        event.stopPropagation();
        event.preventDefault();
        // get closest parent that has data-action attribute, if we click on the +/- icon
        const button = event.target.closest('[data-action]');
        const isExpanded =
            this.contentTarget.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            this.contentTarget.style.height = '0px';
            this.contentTarget.setAttribute('aria-expanded', 'false');
            this.contentTarget.classList.add('hidden');
        } else {
            this.contentTarget.classList.remove('hidden');
            this.contentTarget.style.height =
                this.contentTarget.scrollHeight + 'px';
            this.contentTarget.setAttribute('aria-expanded', 'true');
        }

        // toggle show/hide + and - icons based on new state
        const plusIcon = button.querySelector('span[data-expanded]');
        const minusIcon = button.querySelector('span:not([data-expanded])');
        if (isExpanded) {
            plusIcon?.classList.remove('hidden');
            minusIcon?.classList.add('hidden');
        } else {
            plusIcon?.classList.add('hidden');
            minusIcon?.classList.remove('hidden');
        }
    }
}
